<template>
  <zj-layout-container>
    <zj-layout-header>
      <div class="listtitle">人脸布控</div>
    </zj-layout-header>
    <zj-layout-main>
      <el-form
        ref="form"
        :model="controlobj"
        :rules="rules"
        label-width="8rem"
        v-loading="loading"
        :element-loading-text="loadingText"
        style="height: 100%;"
      >
        <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto;">
          <div class="controlfacediv" style="width:40%;display: flex;align-items: center;">
            <div style="margin:0 auto">
              <div>
                <el-avatar
                  v-if="controlobj.url"
                  shape="square"
                  fit="fill"
                  :src="controlobj.url"
                  :size="350"
                ></el-avatar>
                <div v-else style="width:45rem;height:45rem;border: 1px solid gray;"></div>
              </div>
              <div style="width:100%;height:8rem;display: flex;align-items: center;">
                <div class="AddUploadAuator">
                  <el-upload
                    :show-file-list="false"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :http-request="httpRequest"
                    :before-upload="beforeupload"
                    :on-success="uploadsuccess"
                    :on-progress="uploadProgress"
                    :on-error="uploadError"
                    :data="uploadData"
                    :file-list="fileList"
                  >
                    <div class="el-icon-upload AddUploadAuator">点击上传人脸</div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
          <el-divider direction="vertical" class="controlfacediv" style="height:100%;width:5%"></el-divider>
          <div class="controlfacediv" style="width:55%">
            <div>
              <el-form-item label="人员姓名">
                <el-input v-model="controlobj.Name" placeholder="请输入人员姓名"></el-input>
              </el-form-item>
              <el-form-item label="身份证">
                <el-input v-model="controlobj.Certid" placeholder="请输入身份证"></el-input>
              </el-form-item>
              <el-form-item label="年龄">
                <el-input v-model="controlobj.Age" placeholder="请输入年龄"></el-input>
              </el-form-item>
              <el-form-item label="性别">
                <el-select v-model="controlobj.Sex" placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in SexList"
                    :key="item.value"
                    :label="item.lable"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="评分">
                <el-select v-model="scoreKey" placeholder="请选择" style="width: 100%;">
                  <el-option key label="全部" value></el-option>
                  <el-option
                    v-for="item in score"
                    :key="item.value"
                    :label="item.lable"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </zj-layout-main>
    <zj-layout-footer>
      <el-form>
        <el-form-item class="right" style="width: 134rem;padding-right:5rem">
          <el-button @click="onBack()">返回</el-button>
          <el-button type="primary" @click="onadd()">保存</el-button>
        </el-form-item>
      </el-form>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import ZJApp from "../../../../../app";
export default {
  name: "FaceAddControl",
  controller: "UI",
  action: "FaceAddControl",
  components: {},
  props: {
    query: { type: Object, default: null },
  },
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      controlobj: { url: null },
      SexList: [
        { lable: "男", value: 0 },
        { lable: "女", value: 1 },
      ],
      score: [
        { lable: "90及以上", value: 90 },
        { lable: "80及以上", value: 80 },
        { lable: "70及以上", value: 70 },
        { lable: "65及以上", value: 65 },
      ],
      scoreKey: "",
      uploadData: {
        //todo
        module: "人脸模块", //模块名
        submodule: "", //子模块
        assocID: "rlmk", //业务ID
        uploader: ZJApp.ZJUser.current.UserName, //上传人
        folder: "", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
        ext1: "", //扩展字段 1
        ext2: "", //扩展字段 2
        ext3: 0, //扩展字段 3
      },
      fileList: [],
    };
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
  created: function () {
    if (this.query.url) {
      this.controlobj.url = this.query.url;
      //this.search();
    }
  },
  mounted: function () {},

  methods: {
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    onadd() {
      this.$router.push({
        path: "/plugin/Face/UI/FaceControl",
        query: {  date: new Date() },
      });
    },
    beforeupload: function () {
      this.loading = true;
      this.loadingText = "上传中... 0%";
    },
    uploadsuccess: function (response) {
      this.loading = false;
      if (response.url) {
        this.controlobj.url = response.url;
      }
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      this.loadingText = "上传中... " + parseInt(e.percent) + "%";
    },
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    formatControlStaus(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      var statusstr = "";
      this.ControlStatusArr.forEach((item) => {
        if (item.value == data) {
          statusstr = item.lable;
        }
      });
      return statusstr;
    },
  },
};
</script>
<style scoped>
.AddUploadAuator {
  width: 30rem;
  height: 5rem;
  line-height: 5rem;
  border-radius: 1rem;
  background-color: #386bff;
  margin: 0 auto;
  font-size: 2rem;
  text-align: center;
}

.controlfacediv {
  float: left;
  min-height: 100%;
}
</style>